import { useEffect, useRef } from 'react';

const usePolling = (callback, delay) => {
  const savedCallback = useRef();
  const savedDelay = useRef();

  const timeout = (delayValue) => {
    return new Promise((resolve) => setTimeout(resolve, delayValue));
  }

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    savedDelay.current = delay;
    const poll = async () => {
      if (savedDelay.current) {
        await timeout(savedDelay.current);
        try {
          await savedCallback.current();
        } catch (err) {
          console.log('usePolling error:', err);
        }
        if (savedDelay.current) poll();
      }
    }
    if (delay) {
      poll();
      return () => {
        savedDelay.current = null;
      }
    }
  }, [delay]);
}

export { usePolling };